export const ACORN_QUOTE_MESSAGES = {
    zh: {
        page: {
            brandTagline: "QUOTATION · 报价单",
            subtitle: "填写项目费用明细，生成可分享的报价单图片。",
            generate: "生成报价单图片",
            reset: "重置表单",
            resetDone: "表单已重置",
            generating: "正在生成…",
            generated: "报价单图片已下载",
            failed: "报价单图片生成失败，请重试",
            languageZh: "中文",
            languageEn: "EN",
        },
        form: {
            basicInfo: "基础信息",
            lineItems: "费用明细",
            projectName: "客户名称 / 项目名称",
            projectNamePlaceholder: "如：张三婚礼",
            quoteDate: "报价日期",
            validUntil: "报价有效期",
            currency: "整单币种",
            portfolioUrl: "作品链接",
            portfolioUrlPlaceholder: "小红书主页或其他样片链接",
            hideSubitemPrices: "隐藏所有子项报价",
            globalNotes: "全局备注",
            globalNotesHint: "每条备注单独一行，将显示在报价单底部。",
            globalNotePlaceholder: "输入备注",
            addNote: "添加备注",
            removeNote: "删除",
            itemName: "项目名称",
            itemNamePlaceholder: "如：婚礼跟拍",
            unitPrice: "单价",
            quantity: "数量",
            note: "备注",
            notePlaceholder: "如：含后期 50 张精修",
            subtotal: "小计",
            addLine: "添加一行",
            removeLine: "删除此行",
            grandTotal: "报价总计",
        },
        categories: {
            photography: "拍摄费用",
            equipment: "器材费用",
            travel: "差旅",
            other: "其他",
        },
        validation: {
            projectNameRequired: "请输入客户名称或项目名称",
            portfolioUrlInvalid: "作品链接格式无效，请输入 http 或 https 开头的网址",
        },
        style: {
            heading: "海报样式",
            classic: "经典版",
            editorial: "编辑版",
            livePreview: "实时预览",
        },
        poster: {
            title: "报价单",
            titleEn: "QUOTATION",
            projectPlaceholder: "项目名称",
            validUntil: "有效期至",
            colItem: "项目",
            colCalc: "单价 × 数量",
            colAmount: "金额",
            sectionSubtotal: "小计",
            grandTotal: "合计 TOTAL",
            notesTitle: "备注 NOTES",
            scanZh: "扫码查看样片",
            scanEn: "Scan for portfolio",
            social: "小红书 @英国山橡子影像",
        },
        overlay: {
            saveToPhotos: "保存到相册",
            openImage: "在浏览器中打开",
            close: "关闭",
            shareHint: "在弹出的系统面板中选择“存储图像”即可保存到相册。",
            longPressHint: "也可以长按图片，选择“存储图像”保存到相册。",
            unsupportedShare: "当前浏览器不支持分享图片，请长按图片或点击“在浏览器中打开”。",
        },
    },
    en: {
        page: {
            brandTagline: "QUOTATION · 报价单",
            subtitle: "Fill in the costs and generate a shareable quotation image.",
            generate: "Generate quotation image",
            reset: "Reset form",
            resetDone: "Form reset",
            generating: "Generating…",
            generated: "Quotation image downloaded",
            failed: "Could not generate the quotation image",
            languageZh: "中文",
            languageEn: "EN",
        },
        form: {
            basicInfo: "Basic information",
            lineItems: "Line items",
            projectName: "Client / project name",
            projectNamePlaceholder: "e.g. Zhang San Wedding",
            quoteDate: "Quote date",
            validUntil: "Valid until",
            currency: "Currency",
            portfolioUrl: "Portfolio link",
            portfolioUrlPlaceholder: "Xiaohongshu profile or sample link",
            hideSubitemPrices: "Hide line-item prices",
            globalNotes: "General notes",
            globalNotesHint: "Each note appears on its own line at the bottom of the quotation.",
            globalNotePlaceholder: "Enter a note",
            addNote: "Add note",
            removeNote: "Remove",
            itemName: "Item",
            itemNamePlaceholder: "e.g. Wedding coverage",
            unitPrice: "Unit price",
            quantity: "Qty",
            note: "Note",
            notePlaceholder: "e.g. Includes 50 edited photos",
            subtotal: "Subtotal",
            addLine: "Add line",
            removeLine: "Remove line",
            grandTotal: "Grand total",
        },
        categories: {
            photography: "Photography & video",
            equipment: "Equipment",
            travel: "Travel",
            other: "Other",
        },
        validation: {
            projectNameRequired: "Please enter a client or project name",
            portfolioUrlInvalid: "Invalid portfolio URL. Use an http or https link.",
        },
        style: {
            heading: "Poster style",
            classic: "Classic",
            editorial: "Editorial",
            livePreview: "Live preview",
        },
        poster: {
            title: "QUOTATION",
            titleEn: "ESTIMATE & COSTS",
            projectPlaceholder: "Project name",
            validUntil: "Valid until",
            colItem: "Item",
            colCalc: "Unit × Qty",
            colAmount: "Amount",
            sectionSubtotal: "Subtotal",
            grandTotal: "TOTAL",
            notesTitle: "NOTES",
            scanZh: "扫码查看样片",
            scanEn: "Scan for portfolio",
            social: "小红书 @英国山橡子影像",
        },
        overlay: {
            saveToPhotos: "Save to Photos",
            openImage: "Open image",
            close: "Close",
            shareHint: "Choose Save Image in the system share sheet to save to Photos.",
            longPressHint: "You can also long-press the image and choose Save Image.",
            unsupportedShare: "Sharing is unavailable. Long-press the image or open it in the browser.",
        },
    },
};
